let routes = [{
  path: '/login',
  name: 'login',
  meta: {
    title: 'login',
    icon: '',
    hidden: false
  },
  component: () => import('@/views/login.vue')
}]
export default routes
/* 准备动态添加的路由 */
export const DynamicRoutes = [{
  path: '*',
  name: '404',
  meta: {
    title: '404',
    icon: '',
    hidden: false
  },
  component: () => import('@/components/errpage/404.vue')
},
{
  path: '403',
  name: '403',
  meta: {
    title: '403',
    icon: '',
    hidden: false
  },
  component: () => import('@/components/errpage/403.vue')
},
{
  path: '/',
  meta: {
    title: 'home',
    icon: '',
    hidden: false
  },
  redirect: {
    name: 'home'
  }
},
{
  path: '/home',
  name: 'home',
  meta: {
    title: 'home',
    icon: '',
    hidden: false
  },
  component: () => import('@/views/home.vue')
  // redirect: {name: ''}
}
  // {
  //   path: '/yunweizhichi',
  //   name: 'yunweizhichi',
  //   component: () => import('@/views/home.vue'),
  //   redirect: {name: 'listmanage'},
  //   meta: { title: '运维支持', icon: '', hidden: false },
  //   children: [
  //     {
  //       path: 'listmanage',
  //       name: 'listmanage',
  //       component: () => import('@/views/list/listmanage/index.vue'),
  //       meta: { title: '订单管理', icon: '', hidden: false },
  //       redirect: {name: 'Ddlist'},
  //       children: [
  //         {
  //           path: 'Ddlist',
  //           name: 'Ddlist',
  //           component: () => import('@/views/list/listmanage/list.vue'),
  //           meta: { title: '订单列表', icon: '', hidden: false }
  //         },
  //         {
  //           path: 'detail',
  //           name: 'detail',
  //           meta: { title: '订单详情', icon: '', hidden: false },
  //           component: () => import('@/views/list/listmanage/detail.vue')
  //         }
  //       ]
  //     },
  //     {
  //       path: 'dictionarymanage',
  //       name: 'dictionarymanage',
  //       component: () => import('@/views/list/dictionary/index.vue'),
  //       meta: { title: '字典管理', icon: '', hidden: false },
  //       redirect: {name: 'dictionarylist'},
  //       children: [
  //         {
  //           path: 'dictionarylist',
  //           name: 'dictionarylist',
  //           component: () => import('@/views/list/dictionary/list.vue'),
  //           meta: { title: '字典管理列表', icon: '', hidden: false }
  //         },
  //         {
  //           path: 'dictionarydetail',
  //           name: 'dictionarydetail',
  //           meta: { title: '订单详情', icon: '', hidden: false },
  //           component: () => import('@/views/list/dictionary/detail.vue')
  //         }
  //       ]
  //     }
  //   ]
  // }
]



// WEBPACK FOOTER //
// ./src/router/index.js